/**
 * TODO:
 * - error response
 */

import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { GET_USER_ROLES, SAVE_USER_ROLE } from './actionTypes';
import { getUserRolesSuccess, saveUserRoleSuccess } from './actions';

// AUTH related methods
import { getData, postData } from '../../../helpers/api_helper';

function* fetchUserRoles() {
	try {
		const response = yield call(getData, '/api/user/roles');
		yield put(getUserRolesSuccess(response));
	} catch (error) {
		console.log(error);
	}
}

function* saveUserRole({ payload }) {
	try {
		/*const response = */ yield call(postData, '/api/user/roles', payload);
		yield put(saveUserRoleSuccess(payload));
	} catch (error) {
		console.log(error);
	}
}

export function* watchFetchRoles() {
	yield takeEvery(GET_USER_ROLES, fetchUserRoles);
}

export function* watchSaveUser() {
	yield takeEvery(SAVE_USER_ROLE, saveUserRole);
}

function* rolesSaga() {
	yield all([fork(watchFetchRoles), fork(watchSaveUser)]);
}

export default rolesSaga;
